
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as chuck1QcGGMPKnCTp0LlMA75BvllQg2OaOfgQOA8YemZRDJwMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/chuck.vue?macro=true";
import { default as contactCzXenXCeVNJFOYynjqj8lJ_MdPMWNmmzC0q8JY_oNckMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/contact.vue?macro=true";
import { default as cookies5KOrcW2FPJhRglO7eL1fqg_olBAB5MrNrKTgnbI9HZUMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/cookies.vue?macro=true";
import { default as eventslyuO0Ike7AD35QnI2XgxzfOhJaAbB1cL22c5cBPwvzYMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/events.vue?macro=true";
import { default as privacyyuATCtqRPcmrsQsPKEwTG4G_i7d3z9q_jCSpvYUTCFEMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/privacy.vue?macro=true";
import { default as privatesKJe3ilgRxk80pXmnkxoxQHch8yftDloRCgthU_qav1oMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/privates.vue?macro=true";
import { default as shoesuT5wZ2UguwE_DgpbwAE59vtTvRp4PMYtsSvwdKtO0JcMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/shoes.vue?macro=true";
import { default as terms34Uw_ZWh7NZpcZNiH7tzcOi8ZTzWqxHUB3GAd3I4cZgMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/terms.vue?macro=true";
import { default as videosEKT5EkmBr4bPnlBtA28VWVeaemBMAlFmnAqR4utadQYMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/videos.vue?macro=true";
import { default as indexG868i6eBaeWaHOMicdSgH8ito8nioaNd1I2TFHsNukEMeta } from "/codebuild/output/src1997878616/src/nuxt/pages/index.vue?macro=true";
export default [
  {
    name: "chuck",
    path: "/chuck",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/chuck.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/cookies.vue")
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/events.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/privacy.vue")
  },
  {
    name: "privates",
    path: "/privates",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/privates.vue")
  },
  {
    name: "shoes",
    path: "/shoes",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/shoes.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/terms.vue")
  },
  {
    name: "videos",
    path: "/videos",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/videos.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1997878616/src/nuxt/pages/index.vue")
  }
]